import React, { useRef, useState, useEffect } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import Unmute from "assets/unmute.png";
import Mute from "assets/mute.png";
import Recharge from "assets/recharge.svg";
import Battery from "assets/battery.svg";
import Phone from "assets/phoneVideo.svg";
import Safe from "assets/safe.svg";
import { COLORS, SIZES } from "theme";
import { useTranslation } from "react-i18next";

import H1 from "ReusableComponents/Text/H1";
import Span from "ReusableComponents/Text/Span";
import { LinearProgress } from "@mui/material";
import { usePlayWhenVisible } from "hooks/usePlayWhenVisible";

const VideoSection = ({
  showIcons,
  isOverlay,
  subHeading,
  small,
  formChargingNetwork,
  videoUrl,
  medium,
}) => {
  const videoRef = useRef(null);
  const [mute, setMute] = useState(true);
  const { t } = useTranslation();

  usePlayWhenVisible(videoRef);

  const muteUnmute = () => {
    videoRef.current.muted ^= 1;
    setMute(!mute);
  };

  return !videoUrl ? (
    <LinearProgress />
  ) : (
    <>
      <Box h="auto" position="relative" maxH="773px" paddingTop={SIZES.zero}>
        <Box
          h={
            small
              ? "193px"
              : medium
              ? "calc(100vh - 235px)"
              : "calc(100vh - 120px)"
          }
          maxH={medium ? "474px" : "773px"}
          w="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <Box
            display={showIcons ? "block" : "none"}
            w="100%"
            position="absolute"
          >
            <Box display="flex" justifyContent="space-around">
              <Box display="flex" alignItems="center">
                <img src={Phone} alt="phone" />
                <Text textColor="white" margin="0 12px">
                  No toppling
                </Text>
              </Box>
              <Box display="flex" alignItems="center">
                <img src={Recharge} alt="recharge" />
                <Text textColor="white" margin="0 12px">
                  Recharge
                </Text>
              </Box>
              <Box display="flex" alignItems="center">
                <img src={Safe} alt="safe" />
                <Text textColor="white" margin="0 12px">
                  Safe Cabin
                </Text>
              </Box>
              <Box display="flex" alignItems="center">
                <img src={Battery} alt="battery" />
                <Text textColor="white" margin="0 12px">
                  Battery Temperature
                </Text>
              </Box>
            </Box>
          </Box>
          {formChargingNetwork && (
            <Box
              display={isOverlay ? "block" : "none"}
              w="auto"
              position="absolute"
              left={small ? "40px" : SIZES.eighty}
            >
              <Box display="flex" flexDirection="column">
                <H1
                  w="fit-content"
                  display="flex"
                  flexDirection="column"
                  marginBottom={small ? SIZES.zero : SIZES.twenty}
                >
                  <Span
                    fontSize={small ? SIZES.sizteen : SIZES.forty}
                    w="fit-content"
                    textAlign="center"
                    textColor="white"
                    background={COLORS.black}
                    fontWeight="bold"
                    padding={small ? "0.2em" : "0.3em"}
                  >
                    {t("Charging")}
                  </Span>

                  <Span
                    fontSize={small ? SIZES.sizteen : SIZES.forty}
                    padding={small ? "0.2em" : "0.3em"}
                    background={COLORS.black}
                    textColor="white"
                    w="fit-content"
                    fontWeight="bold"
                    textAlign="center"
                    marginLeft="1em"
                  >
                    {t("network")}
                  </Span>
                </H1>
                <Box w="259px">
                  <Text
                    textColor="white"
                    fontWeight="bold"
                    fontSize={small ? SIZES.twelve : "20px"}
                    lineHeight="1.5"
                  >
                    {subHeading}
                  </Text>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
        <Box background="linear-gradient(to right, rgba(0,0,0,0.65) 0%,rgba(0,0,0,0) 100%)">
          <Box
            borderRadius="50%"
            border="1px solid white"
            background="black"
            style={{
              padding: small ? "12px" : "20px",
              position: "absolute",
              zIndex: 2,
              bottom: small ? 0 : -20,
              right: 24,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              margin: "0 auto",
            }}
          >
            <img
              src={mute ? Unmute : Mute}
              onClick={muteUnmute}
              alt="pause"
              style={{
                height: small ? "16px" : "48px",
                width: small ? "16px" : "48px",
              }}
            />
          </Box>
          <video
            ref={videoRef}
            src={videoUrl}
            type="video/mp4"
            style={{
              width: "100%",
              zIndex: -1,
              position: "absolute",
              top: small ? -20 : -29,
            }}
            playsInline
            muted
            autoPlay
          />
        </Box>
      </Box>
    </>
  );
};

export default VideoSection;
